import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReviewState } from "./interfaces";
import { DEFAULT_REVIEW_POPUP_STATE } from "./constants";

const reviewSlice = createSlice({
	name: "reviewPopupState",
	initialState: DEFAULT_REVIEW_POPUP_STATE,
	reducers: {
		setReviewPopupState: (state: IReviewState, action: PayloadAction<IReviewState>) => {
			const alternatives = "alternatives" in action.payload ? action.payload.alternatives : state.alternatives;
			const edit = "edit" in action.payload ? action.payload.edit : state.edit;
			const create = "create" in action.payload ? action.payload.create : state.create;

			state.alternatives = alternatives;
			state.edit = edit;
			state.create = create;
		},
	},
});

// dle "duck" metodiky jsou akce pojmenovane exporty a reducer default export
export const { setReviewPopupState } = reviewSlice.actions;
export default reviewSlice.reducer;
